import { useTransactionFlowStore } from "@/stores/useTransactionFlowStore";
import { TransactionProgressModal } from "./TransactionProgressModal";

/**
 * Global transaction progress modal driven by Zustand store.
 * Survives component unmounts — render once at the app root.
 */
export function GlobalTransactionModal() {
  const { isOpen, title, steps, error, close } = useTransactionFlowStore();

  return (
    <TransactionProgressModal
      isOpen={isOpen}
      title={title}
      steps={steps}
      onClose={close}
      error={error}
    />
  );
}
